import {
  FIELD_MAPPING,
  HIDDEN_PROPERTIES,
  LabelMap,
  toDisplayNodeSize
} from '../constants/AppConstants';

import { CollapsiblePropertyItem } from '../components/common/CollapsiblePropertyList';
interface Ord {
  [k: string]: number;
}

// Goal of this sort function is to keep the order as [vra, vssc, ...others]
const ordering = {
  vra: 0,
  vssc: 1
};

export const productSorter = ((ord: Ord) => {
  const fallbackOrd = Math.max(...Object.values(ord)) + 1;
  return (p1: string, p2: string) => {
    const o1 = ord[p1] ?? fallbackOrd;
    const o2 = ord[p2] ?? fallbackOrd;
    return o1 === o2 ? p1.localeCompare(p2) : o1 - o2;
  };
})(ordering);

export const columnFilter = (array: any[], property: string, value: string) => {
  array = array.filter(
    u =>
      u[property] &&
      u[property]
        .toString()
        .toLowerCase()
        .indexOf(value.toLowerCase()) > -1
  );
  return array;
};

export const columnSort = (array: any[], property: string) => {
  array = array.sort(
    (a, b) =>
      a[property] && b[property] && a[property].localeCompare(b[property])
  );
  return array;
};

export function filteredAndMapped(
  items: CollapsiblePropertyItem[],
  labelMap: LabelMap = FIELD_MAPPING
): CollapsiblePropertyItem[] {
  return items
    .filter(
      prop =>
        HIDDEN_PROPERTIES.indexOf(prop.name) < 0 &&
        !prop.name.startsWith('_') &&
        prop.value !== '' &&
        prop.value !== null
    )
    .map(item => {
      return {
        ...item,
        value:
          item.name === 'nodeSize' ? toDisplayNodeSize(item.value) : item.value,
        name: labelMap[item.name] || item.name
      };
    })
    .map(item => {
      return {
        ...item,
        value:
          item.key === 'authenticationType'
            ? setAuthenticationType(item.value)
            : item.value,
        name: labelMap[item.name] || item.name
      };
    });
}

export function isCloudApp() {
  const url = window.location.href;
  return url.includes('lcm/cloud');
}

export function setAuthenticationType(value: string) {
  switch (value) {
    case 'vra':
      return 'Automation';
    case 'vsphere':
      return 'vSphere';
    default:
      return '';
  }
}
